export default __webpack_public_path__ + "static/media/Question_icon.b68f4c98.svg";